(()=>{
  function init(){
    const root=document.querySelector('[data-voyage]');
    if(!root||root.dataset.initialized)return;
    root.dataset.initialized='true';
    root.classList.add('vp-interactive');
    const motionPreference=matchMedia('(prefers-reduced-motion: reduce)');
    const reduced=motionPreference.matches;
    const reveal=[...root.querySelectorAll('.vp-reveal')];
    if('IntersectionObserver' in window&&!reduced){
      root.classList.add('vp-js');
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}}),{threshold:.08,rootMargin:'0px 0px 30px 0px'});
      reveal.forEach(el=>observer.observe(el));
    }
    const hero=root.querySelector('.vp-hero'),day=root.querySelector('[data-vp-day]'),night=root.querySelector('[data-vp-night]');
    const ambience=isNight=>{hero.classList.toggle('vp-is-night',isNight);day.setAttribute('aria-pressed',String(!isNight));night.setAttribute('aria-pressed',String(isNight));syncFilms()};
    day.addEventListener('click',()=>ambience(false));night.addEventListener('click',()=>ambience(true));
    const steps=[...root.querySelectorAll('[data-vp-step]')],featureImage=root.querySelector('[data-vp-feature-image]');
    steps.forEach((step,i)=>step.addEventListener('click',()=>{steps.forEach(s=>{s.classList.toggle('is-active',s===step);s.setAttribute('aria-pressed',String(s===step))});featureImage.src=step.dataset.image;featureImage.alt=step.dataset.alt;root.querySelector('[data-vp-feature-count]').textContent=`0${i+1} — 03`;}));
    const play=root.querySelector('[data-vp-play]'),video=root.querySelector('#vp-telematin'),videoError=root.querySelector('.vp-video-error');
    play.addEventListener('click',async()=>{try{video.controls=true;await video.play();play.hidden=true;videoError.hidden=true;}catch{videoError.hidden=false}});
    video.addEventListener('ended',()=>{play.hidden=false});
    video.addEventListener('error',()=>{videoError.hidden=false});
    const variants=[...root.querySelectorAll('[data-vp-variant]')];
    variants.forEach(button=>button.addEventListener('click',()=>{variants.forEach(v=>{v.classList.toggle('is-selected',v===button);v.setAttribute('aria-pressed',String(v===button))});root.querySelector('[data-vp-colour]').textContent=button.dataset.name;root.querySelector('#vp-variant-select').value=button.dataset.id;const image=root.querySelector('.vp-ritual-product-image');image.src=button.dataset.image;image.removeAttribute('srcset');image.alt=button.dataset.name;root.querySelector('[data-vp-price]').textContent=button.dataset.price;}));
    const motions=[...root.querySelectorAll('[data-vp-motion]')];
    const films=[...root.querySelectorAll('[data-vp-film]')];
    const footer=root.querySelector('.vp-footer');
    const visibleZones=new Set();
    let paused=reduced||Boolean(navigator.connection?.saveData);
    const lifecycle=new AbortController();
    const isWanted=film=>!film.dataset.failed&&!paused&&!document.hidden&&visibleZones.has(film.dataset.vpZone)&&(film.dataset.vpZone==='footer'||film.dataset.vpAmbience===(hero.classList.contains('vp-is-night')?'night':'day'));
    function syncFilms(){
      films.forEach(film=>{
        if(!isWanted(film)){film.pause();return}
        if(!film.getAttribute('src')){film.muted=true;film.src=film.dataset.vpSrc;film.load()}
        if(film.paused&&!film.dataset.playPending){
          film.dataset.playPending='true';
          const playback=film.play();
          if(playback)playback.then(()=>{if(!isWanted(film))film.pause()}).catch(()=>{/* Keep the photograph when autoplay is unavailable. */}).finally(()=>{delete film.dataset.playPending});
          else delete film.dataset.playPending;
        }
      });
    }
    films.forEach(film=>{
      film.addEventListener('playing',()=>film.parentElement.classList.add('is-ready'),{signal:lifecycle.signal});
      film.addEventListener('error',()=>{film.dataset.failed='true';film.pause();film.parentElement.classList.remove('is-ready')},{signal:lifecycle.signal});
    });
    const setMotion=()=>{
      document.body.classList.toggle('vp-motion-paused',paused);
      motions.forEach(motion=>{
        motion.setAttribute('aria-pressed',String(paused));
        motion.setAttribute('aria-label',paused?motion.dataset.resume:motion.dataset.pause);
        motion.querySelector('[data-vp-motion-icon]').textContent=paused?'▷':'Ⅱ';
      });
      syncFilms();
    };
    motions.forEach(motion=>motion.addEventListener('click',()=>{paused=!paused;setMotion()}));
    let filmObserver;
    if('IntersectionObserver' in window){
      filmObserver=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          const zone=entry.target===hero?'hero':'footer';
          if(entry.isIntersecting)visibleZones.add(zone);else visibleZones.delete(zone);
          entry.target.classList.toggle('vp-zone-paused',!entry.isIntersecting);
        });
        syncFilms();
      },{threshold:0});
      filmObserver.observe(hero);filmObserver.observe(footer);
    }else{visibleZones.add('hero');visibleZones.add('footer')}
    document.addEventListener('visibilitychange',syncFilms,{signal:lifecycle.signal});
    motionPreference.addEventListener('change',event=>{paused=event.matches;setMotion()},{signal:lifecycle.signal});
    document.addEventListener('shopify:section:unload',event=>{
      if(!event.target.contains(root))return;
      filmObserver?.disconnect();films.forEach(film=>film.pause());lifecycle.abort();
    },{signal:lifecycle.signal});
    setMotion();
    const menu=document.querySelector('#vp-menu'),toggle=document.querySelector('[data-vp-menu]');
    if(menu&&toggle&&!menu.dataset.initialized){
      menu.dataset.initialized='true';
      toggle.addEventListener('click',()=>{menu.showModal();toggle.setAttribute('aria-expanded','true');document.documentElement.style.overflow='hidden'});
      const close=()=>{menu.close()};
      menu.addEventListener('close',()=>{toggle.setAttribute('aria-expanded','false');document.documentElement.style.overflow='';toggle.focus()});
      menu.querySelector('[data-vp-close]').addEventListener('click',close);
      menu.querySelectorAll('a').forEach(a=>a.addEventListener('click',close));
      menu.addEventListener('click',e=>{if(e.target===menu){const r=menu.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right)close()}});
    }
    const sections=[...root.querySelectorAll('section[id]')];
    document.querySelectorAll('a[href^="#voyage-"]').forEach(a=>a.addEventListener('click',e=>{const target=sections.find(s=>'#'+s.id===a.getAttribute('href'));if(target){e.preventDefault();target.scrollIntoView({behavior:paused?'instant':'smooth',block:'start'});history.replaceState(null,'',a.getAttribute('href'));}}));
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
